import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-dashboard" }
const _hoisted_2 = { class: "v-dashboard__wrapper" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" ? ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeading = _resolveComponent("TheHeading")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_TheButton = _resolveComponent("TheButton")!
  const _component_DashboardStudents = _resolveComponent("DashboardStudents")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_DashboardThemes = _resolveComponent("DashboardThemes")!
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TheHeading, {
      level: "h1",
      class: "v-dashboard__heading"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('VIEW_DASHBOARD_HEADING')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_Breadcrumbs),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheButton, {
        to: `/s/grip/laererside`,
        class: "v-dashboard__btn-info",
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_Tabs, {
        ref: "tabs",
        onChanged: _ctx.onChangeTab
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Tab, {
            name: _ctx.$t('VIEW_DASHBOARD_STUDENTS')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DashboardStudents)
            ]),
            _: 1
          }, 8, ["name"]),
          (!_ctx.HIDE_THEMES)
            ? (_openBlock(), _createBlock(_component_Tab, {
                key: 0,
                name: _ctx.$t('VIEW_DASHBOARD_THEMES')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DashboardThemes)
                ]),
                _: 1
              }, 8, ["name"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onChanged"])
    ])
  ]))
}